const config = {
    apiServerUrl: import.meta.env.VITE_API_SERVER_URL,
    managementBaseUrl: import.meta.env.VITE_MANAGEMENT_BASE_URL,
    applicationBaseUrl: import.meta.env.VITE_APPLICATION_BASE_URL,
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
    appVersion: import.meta.env.VITE_APP_VERSION,
    siteKeyForRecaptchaV2: import.meta.env.VITE_SITE_KEY_FOR_RECAPTCHA_V2,
    siteKeyForRecaptchaV3: import.meta.env.VITE_SITE_KEY_FOR_RECAPTCHA_V3,
    gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
};

export default config;